import Vue from 'vue';
import Router from 'vue-router';
import NewRegistration from '@/components/NewRegistration';
import RegistrationSuccess from '@/components/RegistrationSuccess';
import SetPassword from '@/components/SetPassword';

Vue.use(Router);

export default new Router({
  mode: `history`,
  routes: [
    {
      path: `/`,
      name: `NewRegistration`,
      component: NewRegistration,
      props: true,
    },
    {
      path: `/success`,
      name: `RegistrationSuccess`,
      component: RegistrationSuccess,
      props: true,
    },
    {
      path: `/:registrationId`,
      name: `SetPassword`,
      component: SetPassword,
      props: true,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js